<script>
	import { setContext } from 'svelte';
    import Create from './Create.svelte';
    import Join from './Join.svelte';
    import Start from './Start.svelte';
    import Game from './Game.svelte';
    import Alert from "./Alert.svelte";
    import Server, { ServerEvent } from "./server";

    export let isDevMode = false;
    const maintenanceMode = false;//isDevMode ? false : true;
    
    Server.devMode(isDevMode);
    
    const queryString = Object.fromEntries(location.search.replace(/^\?/, '').split('&').map(query => query.split('='))) ?? {};
    
    let publishTestMode = queryString.mode && queryString.mode === 'publish';
    
    let mode = 'home';
    
    let alertModal = {
        on: false,
        message: ''
    };
	
    /**
     * 현재 상태
     * @type {('wait'|'create'|'join'|'quick'|'ongoing')}
     */
    let gameStatus = 'wait';
    
    /**
     * 알리 모달 열기
     * @param {string} msg
     * @param {function|null} callback
     */
    function gameAlert(msg) {
        alertModal.on = true;
        alertModal.message = msg
    };
    
    /**
     * 알림 모달 닫기
     * @param e
     */
    function alertClose(e) {
        if (!alertModal.on) {
            return;
        }
        if (e && e.type === 'keypress' && ![13, 27].includes(e.which)) {
            return;
        }
        alertModal.on = false;
    }
    
    /**
     * 게임 상태 변경
     * @param status
     */
    function statusChange(status) {
        room.gameStatus = status;
    }


	let room = {
        mode: 'home',
		players: 1,
		waitTime: 5,
		auctionTime: 8,
        gameStatus: 'wait'
	}
	let auctionPlayer;
	let biddingInfo = {director: null, point:0};
	let bidInfo;
	let startTime = 0;
	let targetTime = room.waitTime;
	let clientPosition = 0;
	let disconnectedPosition = [];

	const BID_STATE_CONST = {
		READY: 0, //경매 대기 상태
		ON_RECEIVE: 1,//경매 중
		ON_BIDDING: 2,//입찰 중
		SUCCESS: 3,//입찰 성공
		FAIL: 4, //유찰
		FORCE_BID: 5, //선수 변경중
		END: 6, // 경매 종료
		FORCE_READY: 7, //강제 입찰후에 레디 상태

	}
	let bidState = null;

	
	//버튼 동작 파라메터
	let btnClass = {
		create: false,
		start: false,
		attend: false
	};
	
	// 객체 초기화 및 페이지 초기화 소켓 연결 제거
    let initPage = function() {
		btnClass = {
			create: false,
			start: false,
			attend: false
		};
		room = {
            mode: 'home',
			players:1,
			waitTime: 5,
			auctionTime: 8,
            gameStatus: 'wait'
		};
		
		if (ws instanceof SocketClient) {
			ws.disconnect();
		} else {
			console.log('nothing');
		}
	}
	//소켓 ...
	let
        /**
         * @type {SocketClient}
         */
        ws,
        timeHandler;
	const socketAddr = isDevMode && (!queryString.server || queryString.server !== 'live') ? 'http://localhost:9300/' : 'https://jndgame.enchantenter.co.kr';
	let SocketClient = function(addr) {
        /**
         *
         * @type {Server}
         */
		this.socket = null;
		this.addr = addr || socketAddr;
	};
	SocketClient.prototype.connect = function() {
        this.socket = Server.connect(socketAddr);
        
        // - 내가 참가 신청했을 때
        this.socket.addCallback(ServerEvent.JOIN, (data) => {
			clientPosition = data.position;
            room.players = data.players;
        });
        
        // - 누군가 참여했을 때
        this.socket.addCallback(ServerEvent.JOIN_SOMEONE, (data) => {
            room.players = data.players;
        });
        
        // - 누군가 나갔을 시
        this.socket.addCallback(ServerEvent.LEAVE_SOMEONE, (data) => {
			disconnectedPosition.push(data.position);
            room.players = data.players;
        })
        
        // - 준비 체크 - 설정된 시간으로 업데이트
        this.socket.addCallback(ServerEvent.READY_CHECK, (data) => {
            room.waitTime =  data.time.wait;
            room.auctionTime = data.time.auction;
        })
        
        // - 게임시작시 게임모드 전환, wait time 후 경매 시작
        this.socket.addCallback(ServerEvent.START, (data) => {
			auctionPlayer = data.auctionPlayer;
			// console.log(data);
            if (mode !== 'ingame') {
                mode = 'ingame';
            }
			
			bidState = BID_STATE_CONST.READY;
			startTime = Date.now();
			targetTime = room.waitTime;
            timeHandler = setTimeout(() => {
                alertModal.on = false;
				bidState = BID_STATE_CONST.ON_RECEIVE;
                clearTimeout(timeHandler);
                ws.socket.start_auction();
				targetTime = room.auctionTime;
				startTime = Date.now();
                timeHandler = setTimeout(() => {
                    ws.socket.end_auction();
					// bidState = BID_STATE_CONST.END;
                    clearTimeout(timeHandler);
                }, room.auctionTime * 1000);
            }, room.waitTime * 1000);
        });
        
        // - 누군가 입찰
        this.socket.addCallback(ServerEvent.BIDDING, (data) => {
			biddingInfo = data;
            console.log(`bidding : `, data);
            ws.socket.response('bidding')
			bidState = BID_STATE_CONST.ON_BIDDING;
            clearTimeout(timeHandler);
			startTime = Date.now();
            timeHandler = setTimeout(() => {
                ws.socket.end_auction();
				// bidState = BID_STATE_CONST.END;
                clearTimeout(timeHandler);
            }, room.auctionTime * 1000);
        });
        
        // - 유찰
        this.socket.addCallback(ServerEvent.BID_FAILURE, (data) => {
            console.log(`bid_failure : `, data);
            clearTimeout(timeHandler);
			biddingInfo = {director: null, point:0};
			bidState = BID_STATE_CONST.FAIL;
			bidInfo = data;
            timeHandler = setTimeout(() => {
				ws.socket.next();
				clearTimeout(timeHandler);
			}, 1000);
        });
        
        // - 낙찰
        this.socket.addCallback(ServerEvent.BID, (data) => {
            console.log(`bid : `, data);
            clearTimeout(timeHandler);
			biddingInfo = {director: null, point:0};
			bidState = BID_STATE_CONST.SUCCESS;
			
			bidInfo = data;

			timeHandler = setTimeout(() => {
				ws.socket.next();
				clearTimeout(timeHandler);
			}, 1000);
        });
        
        // - 강제 낙찰
        this.socket.addCallback(ServerEvent.BID_FORCE, (data) => {
            console.log(`bid_force : `, data);
			bidInfo = data;
			bidState = BID_STATE_CONST.FORCE_BID;
			biddingInfo = {director: null, point:0};
            timeHandler = setTimeout(() => {
				bidState = BID_STATE_CONST.FORCE_READY;
				ws.socket.next();
				clearTimeout(timeHandler);
			}, 1000);
        });

		this.socket.addCallback(ServerEvent.END, () => {
			bidState = BID_STATE_CONST.END;
            ws.disconnect();
		});
	}
 
	SocketClient.prototype.disconnect = function() {
		this.socket.disconnect();
        delete this.socket;
        this.socket = null;
		console.log('socket close');
		ws = null;
	}
	//메인 버튼 동작 함수
	let mainbuttonEventHandler = {
		eachAction: (e) => {
			if(e.target.dataset.modal == 'start') {
				//방정보 획득 및 연결
                ws = new SocketClient(socketAddr);
                ws.connect();
                ws.socket.quick();
                room.gameStatus = 'quick';
			}
		},
		fire : (e) => {
			if(e.target.dataset.modal) {
				for(let compType in btnClass) {
					btnClass[compType] = false;
				}
				btnClass[e.target.dataset.modal] = true;
			}
			mainbuttonEventHandler.eachAction(e);
		},
		
	};
	
	let _players = {};
	let _headcoach = {};
	Object.assign(_players,PARTICIPANTS.players);
	Object.assign(_headcoach,PARTICIPANTS.head_coach);
    
    Server.setModal(gameAlert);
    Server.setStatusChange(statusChange);
    
    $: {
        console.log(room.gameStatus);
        if (room.gameStatus === 'error') {
            initPage();
        }
    }
    
</script>

<svelte:window on:keypress={alertClose}/>

<div class="inner">
    <h2 class="blind">메인 영역</h2>
    <p class="sub-title">
        <img src="https://static.inven.co.kr/image_2011/enchantenter/220509/logo-sponsor-intel.png?v=220516b" alt="INTEL">
        <img src="https://static.inven.co.kr/image_2011/enchantenter/220509/logo-sponsor-legion.png" alt="LEGION">
    </p>
    <section class="game-wrap">
        <h3 class="blind">모의 경매</h3>
        <!-- ========== 홈 화면 ========== -->
        {#if mode === 'home'}
            <!-- S : PAGE[1] - 메인 화면 -->
            <div class="game-info">
                {#if !maintenanceMode}
                <p class="info">
                    자낳대 팀원 경매를 체험해보세요.<br>
                    <strong>6명의 플레이어</strong>가 모여야 진행할 수 있습니다.
                </p>
                {/if}
                {#if maintenanceMode}
                <!-- S : 점검 화면 -->
                <div class="maintenance-info-box">
                    <p class="maintenance-info">
                        안정적인 운영을 위해 서버 점검 작업을 진행할 예정입니다.<br>
                        작업 시간 중에는 서비스 이용에 제한이 있을 수 있으니<br>
                        이점 양해 부탁드립니다.
                    </p>
                    <dl class="list">
                        <div class="group">
                            <dt>작업내용:</dt>
                            <dd>서버 점검</dd>
                        </div>
                        <div class="group">
                            <dt>작업일시:</dt>
                            <dd>
                                <span class="date">5/20(금) 19:30 ~ 20:00</span> (30분 소요 예정)<br>
                                <span class="desc">(작업에 따라 다소 시간이 지열될 수 있습니다.)</span>
                            </dd>
                        </div>
                    </dl>
                </div>
                <!-- E : 점검 화면 -->
                {/if}
                {#if !maintenanceMode}
                <div class="btn-wrap">
                    <button type="button" class="btn" data-modal="start" on:click={(e)=>{ mainbuttonEventHandler.fire(e)}}>게임 시작</button>
                    <button type="button" class="btn" data-modal="create" on:click={(e)=>{ mainbuttonEventHandler.fire(e)}}>방 생성</button>
                    <button type="button" class="btn" data-modal="attend" on:click={(e)=>{ mainbuttonEventHandler.fire(e)}}>방 참가</button>
                </div>
                {/if}
                <p class="supported-by">thanks to 레드다이어리</p>
            </div>
            <!-- E : PAGE[1] - 메인 화면 -->
      
            {#if !maintenanceMode}
            <!-- ========== 방 생성 ========== -->
            <Create btnClass={btnClass} initPage={initPage} bind:room bind:gameStatus bind:SocketClient bind:ws {socketAddr} {gameAlert} bind:alertModal />
            <!-- ========== 방 참가 ========== -->
            <Join btnClass={btnClass} initPage={initPage} bind:room bind:gameStatus bind:SocketClient bind:ws {socketAddr} {gameAlert} bind:alertModal />
            <!-- ========== 게임시작 ========== -->
            <Start initPage={initPage} bind:room />
            <!-- ========== 게임화면 ========== -->
                {#if publishTestMode}
                    <Game {_players} {auctionPlayer} {room} {ws} {clientPosition} {_headcoach} {biddingInfo} {bidInfo} {startTime} {targetTime} {bidState} {BID_STATE_CONST} {publishTestMode} {disconnectedPosition}/>
                {/if}
            {/if}
        {:else}
            {#if !maintenanceMode}
            <Game {gameAlert} {_players} {room} {auctionPlayer} {ws} {clientPosition} {_headcoach} {bidInfo} {biddingInfo} {startTime}  {targetTime} {bidState} {BID_STATE_CONST} {disconnectedPosition}/>
            {/if}
        {/if}
        {#if !maintenanceMode}
        <Alert bind:alertModal />
        {/if}
    </section>
</div>
<style global lang="scss">
</style>